<template>
<div>
    <SelectListPaginated 
        :options="stopOptions" 
        :value="selection" 
        @select="onSelectItem" 
        :searchable="true" 
        :disabled="loading"
        :optionsPerPage="10" 
        :placeholder="$t('timetables.search_stop')"
        :clearable="true"
        :noreduce="true"
        :label="$t('timetables.add_stop')" 
        :selectable="(option) => selectable(option)" 
        />

    <hr>

    <label>{{ $t('timetables.attached_stops') }}</label>
    <collapse id="timetableviewstops" class="viewstops">
        <collapse-item v-for="(stop, index) in viewStops" :key="stop.id" :title="getName(stop)" :name="getName(stop)">
              <div slot="title" class="stop">
                  <div class='pri'>{{stop.priority}}</div>
                  <div class='id'>
                      <div>{{stop.stop.id}}</div> 
                      <div v-if="stop.stop.label" class='label'>({{ stop.stop.label }})</div>
                      <div v-if="stop.stop.platform && stop.stop.platform.trim().length > 0 && stop.stop.platform != '0'" class='platform'>[{{ stop.stop.platform }}]</div> 
                  </div>
                  <div class='name'>{{stop.stop.name}}</div>
              </div>

            <div class='actions'>
                <div class="float-left" v-if="$UIPrivilege('content/timetables', 'stops.priority')">
                    <b-icon v-if="stop.priority > 1" icon="sort-numeric-up" scale='1.3' @click="setPriority(stop, stop.priority - 1 )" :title="$t('timetables.priority.up')" />
                    <b-icon v-if="index < viewStops.length - 1" icon="sort-numeric-down" scale='1.3' @click="setPriority(stop, stop.priority + 1)" style="margin-left: 15px" :title="$t('timetables.priority.down')"/>
                </div>
                <div class="float-right">
                    <b-icon icon="x" variant="danger" scale='1.8' @click="onDeleteStop(stop.id)" :title="$t('button.delete')" style="margin-right: 8px" />
                </div>
            </div>


            <div v-for="route in stop.routes" :key="route.id" :class="'route state-'+route.state ">
                <div class='state' @click="toggleState(stop, route)">
                    <b-icon v-if="route.state == 0" icon="dash-circle" variant="danger" scale="1.3"/>
                    <b-icon v-if="route.state == 1 || route.state == 4" icon="check-circle" variant="success" scale="1.3"/>
                    <b-icon v-if="route.state == 2 || route.state == 3" icon="x-circle" variant="secondary" scale="1.3"/>
                </div>
                <div class='line'>{{ route.line}}</div>
                <div class='order'>[{{ route.order }} / {{ route.maxOrder }}]</div>
                <div class='dest'>{{ route.destination}}</div>
                <div v-if="route.state != 1" class='state-text'><b-icon icon="exclamation-triangle-fill" scale="1.2" style="margin-right: 6px;"/>{{  $t('timetables.route_state.'+route.state) }}</div>
            </div>
        </collapse-item>
    </collapse>
    <span v-if="viewStops.length == 0" class="info note">{{ $t('timetables.no_stops') }}</span>
   
    <div v-if="externalDataSources.length > 0" style="margin-top: 50px">
        <hr>
        <label>{{ $t('timetables.external_source') }}</label>
        <!--
        <div v-for="ds in externalDataSources" :key="ds.id" class='link'>

             <b>MQTT</b> / <a :href="ds.url">{{ ds.url }}</a>
        </div>
        -->
        
         <div v-for="ds in externalDataSources" :key="ds.id">
            <b-row>
                <b-col cols="3"><fg-input :value="ds.source" :label="$t('timetables.source')" disabled="true"></fg-input> </b-col> 
                <b-col> <fg-input :value="ds.url" :label="$t('timetables.url')" disabled="true"></fg-input></b-col> 
            </b-row>
            <!--
            <fg-input :value="ds.url" :label="$t('timetables.url')" disabled="true"></fg-input>
            -->
         </div>

    </div>


    <t-button v-if="viewStops.length > 1" type="rm" @click="removeAll" :disabled="loading" style='float:right'>{{ $t('button.remove-all') }}</t-button> 


    <RequestInfo type="custom" :loader="loading" :ok="ok" :okMsg="okMsg"/>

<!--
    <div v-if="viewStops.length > 1" style='text-align:right; font-size: 14px'>
        <button type="submit" class="btn-x rm" @click="removeAll()" >
            <b-icon icon="x"></b-icon><span>{{ $t('button.remove-all') }}</span> 
        </button>    
    </div>
-->
     


    <!-- <b-modal id="deleteStop" static @ok="removeOK" :title='delModalTitle'>{{ $t("device_view.delete_confirm.msg") }}</b-modal> -->
</div>
</template>


<script>

import SelectListPaginated from '@/components/Misc/SelectListPaginated'
import stop from '@/store/timetable/stop'
import i18n from '@/i18n'

export default {
    components: { SelectListPaginated },
    props: ['item'],
    data(){
        return {
            loading: false,
            ok: false,
            okMsg: "",
            selection: "",
            viewStops: [],
            externalDataSources: []
        }
    },
    computed: {
        stopOptions(){
            var optionList = [];

            // stops
            for (let item of this.$store.state.stop.stopList) {
                let label = item.tunnus;
                if(item.sms) label += " (" + item.sms + ")";
                label += " - " + item.nimi; 

                optionList.push({ id: item.tunnus, label: label, icon: "geo-alt-fill", variant: "danger", method: "add" })
            }
            
            // timetable views
            for (let item of this.$store.state.timetableview.views) {
                let label = item.id + " - " + item.name;
                optionList.push({ id: item.id, label: label, icon: "card-list", variant: "success", method: "copy" })
            }
        


            return optionList;
        }
    },
    watch: {
        item(){
            this.viewStops = [];
            this.externalDataSources = [];
            this.selection = null;
            this.getTimetableViewStops();
            this.getExternalDataSources();
        }
    },
    created(){
        this.getTimetableViewStops();
        this.getExternalDataSources();

        if (!this.$store.state.stop) this.$store.registerModule("stop" , stop);
        
        this.$store.dispatch('stop/getStopList');
    },
    methods: {
        selectable(option){
            //console.log("selectable");
            var current = new Set(this.viewStops.map(item => item.stop.id));
            return(!current.has(option.id));
        },
        getTimetableViewStops(){
            this.loading = true;
            if(this.item){
                this.$traveller_http.get('/traveller/restui/content/timetableview/routes', { params: { "id": this.item.id} })
                .then( response => {
                    this.viewStops = response.data
                    //console.log(this.viewStops[0].stop.id);
                    //var current = new Set(this.viewStops.map(item => item.stop.id));
                    //console.log(this.selectable(this.viewStops[0].stop));
                   
                 })
                .catch( () => {} ) 
                .finally( () => { this.loading = false; } ); 
            }
        },
        getExternalDataSources(){
            if(this.item){
                this.$traveller_http.get('/traveller/restui/content/timetableview/externalSources', { params: { "id": this.item.id} })
                .then( response => {
                    this.externalDataSources = response.data
                 })
                .catch( () => {} ) 
                .finally( () => {} ); 
            }
        },
        
        getName(viewStop){
            return  viewStop.stop.id + " - " + viewStop.stop.name
        },
        onSelectItem(stopOrView){
            if(stopOrView){
                this.loading = true;  this.ok = false;
                this.selection = stopOrView;
                
        
                var params = "id=" + this.item.id + "&from=" + stopOrView.id + "&method=" + stopOrView.method;
                this.$traveller_http.post('/traveller/restui/content/timetableview/addStops', params  )
                .then( response => {
                    console.log(response);
                    
                    if(response.data.errorCode == 0){
                        this.getTimetableViewStops();
                        this.$store.dispatch('timetableview/stops')
                    }
                    
                })
                .catch( () => {} ) 
                .finally( () => {  this.loading = false; this.ok = true; this.okMsg = i18n.t('alert.save.ok'); } ); 
                
            }
        },
        onDeleteStop(stop){
           if(stop){
                //this.$bvModal.show('deleteStop')
                
                 this.loading = true;  this.ok = false;
                 this.$traveller_http.get('/traveller/restui/content/timetableview/deleteStop', { params: { "id": stop} })
                .then( response => {
                    if(response.data.errorCode == 0){
                        this.getTimetableViewStops();
                        this.$store.dispatch('timetableview/stops')
                    }
                 })
                .catch( () => {} ) 
                .finally( () => { this.loading = false; this.ok = true;  this.okMsg = i18n.t('alert.delete.ok');  } ); 
            }
            
        },
        setPriority(stop, newPriority){
            //let currentPriority = stop.priority;
            this.loading = true;  this.ok = false;
            var params = "id=" + stop.id + "&pri=" + newPriority;
            this.$traveller_http.post('/traveller/restui/content/timetableview/setPriority', params  )
            .then( response => {
                if(response.data.errorCode == 0){
                    this.getTimetableViewStops();
                   
                }
             })
            .catch( () => {} ) 
            .finally( () => { this.loading = false; this.ok = true;  this.okMsg = i18n.t('alert.save.ok');  } ); 
        },
        toggleState(displayStop, routeStop){
            //console.log(displayStop.id + "/"+ routeStop.id);
            this.loading = true;  this.ok = false;
            var params = "id=" + displayStop.id + "&rsid=" + routeStop.id;
            this.$traveller_http.post('/traveller/restui/content/timetableview/toggleState', params  )
            .then( response => {
                if(response.data.errorCode == 0){
                    this.getTimetableViewStops();
                   
                }
             })
            .catch( () => {} ) 
            .finally( () => { this.loading = false; this.ok = true;  this.okMsg = i18n.t('alert.save.ok');  } ); 
        },
        removeAll(){
            this.loading = true;
            this.$traveller_http.get('/traveller/restui/content/timetableview/removeStops', { params: { "id": this.item.id } })
            .then( response => {
                if(response.data.errorCode == 0){
                    this.getTimetableViewStops();
                    this.$store.dispatch('timetableview/stops');
                }
            })
            .catch( () => {} ) 
            .finally( () => {} );         
        }

    }
}

</script>

<style lang="scss">

#timetableviewstops {
    .collapsed {
        background: #f5f5f5;
    }

    
    .card-body {
        padding: 10px;
    }
 
}



</style>

<style scoped lang="scss">



.stop {
    display: inline-block;

    /* display: flex; */
    text-decoration: none;
    
    font-family: Verdana, Arial, Helvetica, sans-serif;
    font-size: 12px;
    
    div { 
        display: inline-block; 
    }
    .pri {
        width: 20px;
        border-radius: 50%;
        color: #fff;
        text-align: center;
   
        font-size: 12px;
        background: #007AC9;
/*
        width: 20px;
        height: 20px;
        padding: 1px;
*/
        width: 25px;
        height: 25px;
        padding-top: 4px;


    }
 
    .id {
        margin-left: 20px;
        width: 70px;
        min-width: 160px;

        .label, .platform {
            font-weight: normal;
            margin-left: 6px;
        }

        
    }

    .name {
        /*font-weight: normal;*/
        text-transform: none;
    }
}


.actions {
    height: 40px;

    .b-icon {
        cursor: pointer;
        /* margin-left: 15px; */
    }


}

.route {
    font-family: Verdana, Arial, Helvetica, sans-serif;
    font-weight: bold;
    font-size: 10px;
    padding: 5px 5px;
    border-bottom: 1px solid #ccc;

    background: #fff;

    &.state-0, &.state-2, &.state-3 {
        color: #bbb;
    } 

    &:hover{
        background: #ccc;
    }

    div { 
        display: inline-block;
    }

    .state {
        width: 50px;
        &:hover {
            cursor: pointer;
        }

    }

    .line,
    .order {
        width: 60px;
    }

     .order {
         width: 70px;
     }

    .dest {
        &:hover {
            cursor: pointer;
        }
    }

    .state-text {
        float: right;
        font-style: italic;
    }
}

.card-body {
    padding: 5px;
}


.link {
    margin: 2px 0 15px 0;
    padding: 20px 10px;
    border: 1px solid #ccc;
    font-size: 14px;
    text-align: center;
}


</style>